import React, { useState, useEffect } from 'react';
import {
  Stack,
  Typography,
  TextField,
  Box,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

const TitleSection = ({ initialTitle, onSave, selectedData }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [title, setTitle] = useState(initialTitle);
  const [originalTitle, setOriginalTitle] = useState(initialTitle);

  useEffect(() => {
    setTitle(initialTitle);
  }, [initialTitle]);

  const handleStartEditing = () => {
    setOriginalTitle(title);
    setIsEditing(true);
  };

  const handleSave = async () => {
    if (title.trim() === '') {
      // Maybe show a toastr
      return;
    }
    const success = await onSave({ title });
    if (success) {
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setTitle(originalTitle);
    setIsEditing(false);
  };

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      {isEditing ? (
        <>
          <TextField
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            variant="outlined"
            size="small"
            autoFocus
          />
          <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
            <Box onClick={handleSave} sx={{ cursor: 'pointer', color: 'primary.main' }}>
              <DoneIcon sx={{ fontSize: '20px' }} />
            </Box>
            <Box onClick={handleCancel} sx={{ cursor: 'pointer', color: 'error.main' }}>
              <CloseIcon sx={{ fontSize: '20px' }} />
            </Box>
          </Box>
        </>
      ) : (
        <>
          <Typography
            sx={{
              color: '#181818',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
            }}
            onClick={handleStartEditing}
          >
            {title}
          </Typography>
        </>
      )}
       {(selectedData?.isHold === true) && (
          <Typography
            sx={{
              background: "#f7f7f7",
              fontWeight: 800,
              color: "#565656",
              borderRadius: "20px",
              border: "1px solid #959595",
              padding: "0 6px",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            Hold
          </Typography>
        )}
    </Stack>
  );
};

export default TitleSection;
